import Spin from 'antd/lib/spin';
import React from 'react';
import './FullscreenLoaderStyles.css';

const FullscreenLoader: React.FC = () => (
  <div className="full-screen-wrapper">
    <Spin size="large" className="spinner" />
  </div>
);

export default FullscreenLoader;



// WEBPACK FOOTER //
// ./src/components/FullscreenLoader/FullscreenLoader.tsx